import { createContext, useContext } from "react";
import type { RapidWorkflowDataType } from "@/components/flow/shared/Deploy/documentation/types";

export interface WorkflowContextValue {
    currentWorkflow: RapidWorkflowDataType | null;
    setCurrentWorkflow: (workflow: RapidWorkflowDataType | null) => void;
}

export const WorkflowContext = createContext<WorkflowContextValue | null>(null);

export function useWorkflowContext() {
    const ctx = useContext(WorkflowContext);
    if (!ctx) throw new Error("useWorkflowContext must be used within WorkflowProvider");
    return ctx;
}
